<template>
  <div>
    <h3>Planday - Portals</h3>

    <!-- <div style="text-align: right;">
      <vs-button
          @click="syncPortals"
          id="sync-portals-button"
          class="mt-4"
        >Sync Portals
      </vs-button>
    </div> -->

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="portals"
      @selected="onPortalClicked(selected)"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                portals.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : portals.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="serviceKey">Service</vs-th>
        <vs-th sort-key="id">Planday Portal ID</vs-th>
        <vs-th sort-key="numEmployees">Num. Employees</vs-th>
        <vs-th sort-key="numEmployees">Num. Groups</vs-th>
        <vs-th sort-key="didSync">Synced</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.serviceKey }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.numEmployees }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.numEmployeeGroups }}</p>
            </vs-td>
            <vs-td>
              <vs-icon
                v-if="!tr.hasWarnings"
                icon="check"
                size="small"
                color="white"
                bg="lightgreen"
                round
              ></vs-icon>
              <vs-icon v-if="tr.hasWarnings" icon="minus" size="small" color="white" bg="red" round></vs-icon>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      portals: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.portals.length;
    },
  },
  methods: {
    getPortals: function () {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/planday?query=" + this.query)
        .then(resp => {
          this.portals = resp.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    syncPortals: function () {
      this.$vs.loading();

      this.$http
        .post(process.env.VUE_APP_API + "/planday")
        .then((/*resp*/) => {
          this.getPortals();
          //this.portals = resp.data;

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Planday Venues synced",
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not sync Planday Venues:" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onPortalClicked(portal) {
      this.$router.push({ name: "admin-planday-portal", params: { portalId: portal.id } }).catch(() => {});
    },
  },
  created() {
    this.getPortals();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>